export default function MarketAnalysisSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Market Analysis
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            El Paso Apartment Market Analysis
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Understanding the El Paso apartment market helps you make informed decisions about when and how to sell my apartments for maximum value.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Current El Paso Multi-Family Market</h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              El Paso's apartment market has shown strong fundamentals over the past several years. With a growing population, steady job growth, and affordable housing demand, multi-family properties remain attractive investments for apartment buyers.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              However, market conditions can change quickly. Interest rates, economic factors, and local market dynamics all affect apartment values. That's why many property owners choose to sell my apartments now while market conditions remain favorable.
            </p>

            <div className="space-y-4">
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-gray-900">Average Occupancy Rate</span>
                  <span className="text-2xl font-bold text-teal-600">94%</span>
                </div>
                <p className="text-gray-600">El Paso apartments maintain high occupancy rates</p>
              </div>
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-gray-900">Average Cap Rate</span>
                  <span className="text-2xl font-bold text-teal-600">6.5-8%</span>
                </div>
                <p className="text-gray-600">Competitive returns for multi-family investors</p>
              </div>
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-gray-900">Median Rent Growth</span>
                  <span className="text-2xl font-bold text-teal-600">+4.2%</span>
                </div>
                <p className="text-gray-600">Annual rent growth supports property values</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/220e6afd1e9991825c238ca597d85750.jpg"
              alt="El Paso Apartment Market"
              className="rounded-2xl shadow-2xl w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-12 text-white">
          <h3 className="text-3xl font-bold mb-8 text-center">Why Now Is a Good Time to Sell My Apartments</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-xl font-bold mb-4 text-teal-400">Market Factors</h4>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <i className="ri-arrow-right-circle-fill text-teal-400 flex-shrink-0 mt-1"></i>
                  <span>Strong demand from apartment buyers seeking cash-flowing properties</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-arrow-right-circle-fill text-teal-400 flex-shrink-0 mt-1"></i>
                  <span>El Paso population growth driving rental demand</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-arrow-right-circle-fill text-teal-400 flex-shrink-0 mt-1"></i>
                  <span>Limited new apartment construction maintaining property values</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-arrow-right-circle-fill text-teal-400 flex-shrink-0 mt-1"></i>
                  <span>Favorable cap rates attracting out-of-state investors</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-xl font-bold mb-4 text-teal-400">Personal Factors</h4>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <i className="ri-arrow-right-circle-fill text-teal-400 flex-shrink-0 mt-1"></i>
                  <span>Tired of dealing with tenant issues and property management</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-arrow-right-circle-fill text-teal-400 flex-shrink-0 mt-1"></i>
                  <span>Need to liquidate assets for retirement or other investments</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-arrow-right-circle-fill text-teal-400 flex-shrink-0 mt-1"></i>
                  <span>Facing deferred maintenance costs that exceed available capital</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-arrow-right-circle-fill text-teal-400 flex-shrink-0 mt-1"></i>
                  <span>Want to take advantage of current market values before potential changes</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}